import WalletConnectWallet from './WalletConnectWallet'

const walletConnectInstance = new WalletConnectWallet()

export default walletConnectInstance
